import React from 'react';

import {PerUserRequired} from 'app/toasts/components/PerUserRequired';
import {UPGRADE_MODALS} from 'app/toasts/slice';
import {gt} from 'app/utils/i18n';

interface Props {
  showModal: () => void;
  className?: string;
}

export const AddSignoffRulesButton = ({showModal, className}: Props) => {
  return (
    <PerUserRequired
      actionToProtect={showModal}
      modalType={UPGRADE_MODALS.SETUP_TEAM_SIGNOFF}
    >
      {(protectedAction) => (
        <button
          className={className ?? 'btn btn-light'}
          onClick={protectedAction}
        >
          <i className="fas fa-plus-circle mr-1" /> {gt('Add Sign Off Rules')}
        </button>
      )}
    </PerUserRequired>
  );
};
